import { FunctionComponent, ReactNode } from 'react';
import './styles/IllustrationStage.scss';

import { Stack } from '@mui/material';

import { classNames, componentClassName } from '@dw/utils';

interface IIllustrationStageProps {
  children: ReactNode;
  /** Holds the drawing in view while a taller-than-the-viewport form scrolls past it. */
  sticky?: boolean;
  className?: string;
}

const cn = componentClassName('illustration-stage');

/**
 * The ground every drawing in Settings stands on.
 *
 * One component rather than a repeated background, because this tint and this dashed edge are the
 * whole cohesion device: wherever an owner sees them they know they are looking at a picture of a
 * consequence and not at another panel of the portal they could click.
 */
export const IllustrationStage: FunctionComponent<IIllustrationStageProps> = ({ children, sticky, className }) => (
  <Stack
    className={classNames(cn(), { [cn('sticky')]: !!sticky }, className)}
    alignItems='center'
  >
    {children}
  </Stack>
);
